import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { apiRequest } from "../../api/actions";
import { createErrorNotification } from "../../notification/actions";
import { sendVerificationCodeSuccess, sendVerificationSmsSuccess } from "./actions";

export const sendVerificationSmsMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.SEND_VERIFICATION_SMS:

    next(apiRequest(
      null,
      'POST', ApiUrls.VERIFICATION_SMS,
      null,
      action.payload,
      MiddlewareEntities.ORDER.SEND_VERIFICATION_SMS,
      {}),
    );
    break;
  case `${MiddlewareEntities.ORDER.SEND_VERIFICATION_SMS} ${ActionTypes.API_SUCCESS}` :
    next(sendVerificationSmsSuccess(!!action.payload.data.sentSms));
    break;
  case `${MiddlewareEntities.ORDER.SEND_VERIFICATION_SMS} ${ActionTypes.API_ERROR}` :
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.ORDER.SEND_VERIFICATION_SMS));
    break;
  }
};

export const sendVerificationCodeMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.SEND_VERIFICATION_CODE:

    next(apiRequest(
      null,
      'PATCH', ApiUrls.VERIFICATION_SMS,
      null,
      action.payload,
      MiddlewareEntities.ORDER.SEND_VERIFICATION_CODE,
      {}),
    );
    break;
  case `${MiddlewareEntities.ORDER.SEND_VERIFICATION_CODE} ${ActionTypes.API_SUCCESS}` :
    next(sendVerificationCodeSuccess(!!action.payload.data.codeVerified));
    break;
  case `${MiddlewareEntities.ORDER.SEND_VERIFICATION_CODE} ${ActionTypes.API_ERROR}` :
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.ORDER.SEND_VERIFICATION_CODE));
    break;
  }
};

export const verificationSmsMiddleware = [sendVerificationSmsMiddleware, sendVerificationCodeMiddleware];
